module.exports = "img/4.62d884.webp";